import { useParams } from "react-router-dom";
import { IndividualCounselingProjectContentsItem } from "../../features/api-interfaces";
import { IndividualCounselingProjectContentsForm } from "./Main";

export const Update = () => {
  //情報取得API呼び出し(個別相談案-相談内容)
  const { individualConsultationNo, individualConsultationBranchNo } =
    useParams();

  //取得API用のパラメーターの要素
  const params: IndividualCounselingProjectContentsItem = {
    individualConsultationNo: Number(individualConsultationNo),
    individualConsultationBranchNo: Number(individualConsultationBranchNo),
  };

  return <IndividualCounselingProjectContentsForm params={params} />;
};
